var _rect, _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecoverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 124,
    fill: "white",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 39,
    width: 200,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 39.4194H24V84.5807H224V39.4194Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_302_972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 39,
    width: 200,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224 39.4194H24V84.5807H224V39.4194Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_302_972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_302_972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 39,
    width: 198,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.387 39.4194H25.6128V84.5807H222.387V39.4194Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_302_972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_302_972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 39,
    width: 198,
    height: 46
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.387 39.4194H25.6128V84.5807H222.387V39.4194Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_302_972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6128 -8.79175H225.613V135.976H25.6128V-8.79175Z",
    fill: "url(#pattern0_302_972)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_302_972",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_302_972",
    transform: "scale(0.00819672 0.011236)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 45.1613,
    fill: "white",
    transform: "translate(24 39.4194)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_302_972",
    width: 122,
    height: 89,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoverse);
export default __webpack_public_path__ + "static/media/decoverse.ae0eca76a4b4c5b5a9d83a7b23ab438e.svg";
export { ForwardRef as ReactComponent };